import { ActionType } from "../action-types/index";
import { Action } from "../actions";

export interface ReduxState {
  langValue: string;
  formData: any;
  freezScreen: boolean;
  alert: any;
  shopUrl: any;
  userInfo: any;
  loggedIn: any;
  token: string;
  storeManagerList: any;
  segmentSettings: any;
  customerSegmentInfo: any;
  paymentMethodPopUp: boolean;
  bookingForm: any | null;
  extrasFieldsPopup: any;
  cart: any;
  authToken: any;
  deviceId: any;
  bookingTotal: any;
  timeCacheCreatedAt : any;
  redirectCheckout: any;
  loginModal: boolean;
  otpModal: boolean;
  loginValues: any;
  loginSkip: boolean;
  guestLoggedIn: boolean;
  pendingCheckout: boolean;
}

const initialState = {
  notes: [],
  langValue: "en",
  formData: [],
  freezScreen: false,
  alert: {
    show: false,
    message: "",
  },
  shopUrl: "",
  userInfo: {},
  loggedIn: false,
  token: "",
  storeManagerList: null,
  segmentSettings: null,
  customerSegmentInfo: {},
  paymentMethodPopUp: false,
  bookingForm: null,
  extrasFieldsPopup: false,
  cart: [],
  authToken: "",
  deviceId: null,
  bookingTotal: null,
  timeCacheCreatedAt : null,
  redirectCheckout: false,
  loginModal: false,
  otpModal: false,
  loginValues: {
    phoneCode: "965",
    phoneNumber: "",
    fullName: "",
    email: "",
    provider: "",
    storeId: "",
    branchId: "",
  },
  loginSkip: false,
  guestLoggedIn: false,
  pendingCheckout: false
};

const reducer = (state: ReduxState = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.SET_LANG_VALUE:
      return { ...state, langValue: action.payload };
    case ActionType.SET_FREEZ_SCREEN:
      return { ...state, freezScreen: action.payload };
    case ActionType.SET_FORMDATA:
      return { ...state, formData: action.payload };
    case ActionType.SET_ALERT_MESSAGE:
      return { ...state, alert: action.payload };
    case ActionType.SET_SHOP_URL:
      return { ...state, shopUrl: action.payload };
    case ActionType.SET_USER_INFO:
      return { ...state, userInfo: action.payload };
    case ActionType.SET_LOGGED_IN:
      return { ...state, loggedIn: action.payload, token: action.token };
    case ActionType.SET_STORE_MANAGER_LIST:
      return { ...state, storeManagerList: action.payload };
    case ActionType.SET_SEGMENT_SETTINGS:
      return { ...state, segmentSettings: action.payload };
    case ActionType.SET_CUSTOMER_SEGMENT_INFO:
      return { ...state, customerSegmentInfo: action.payload };
    case ActionType.SET_BOOKING_FORM:
      return { ...state, bookingForm: action.payload };
    case ActionType.SET_PAYMENT_METHOD_POPUP:
      return { ...state, paymentMethodPopUp: action.payload };
    case ActionType.SET_EXTRAS_FIELDS_POPUP:
      return { ...state, extrasFieldsPopup: action.payload };
    case ActionType.SET_CART:
      return { ...state, cart: action.payload };
    case ActionType.SET_AUTH_TOKEN:
      return { ...state, authToken: action.payload };
    case ActionType.SET_DEVICE_ID:
      return { ...state, deviceId: action.payload };
      case ActionType.SET_BOOKING_TOTAL:
        return{...state, bookingTotal: action.payload}
    case ActionType.SET_TIME_CACHE_CREATED_AT:
      return{...state, timeCacheCreatedAt: action.payload}
      case ActionType.SET_REDIRECT_CHECKOUT:
        return{...state, redirectCheckout: action.payload}
    case ActionType.SET_LOGIN_MODAL:
      return { ...state, loginModal: action.payload };
    case ActionType.SET_OTP_MODAL:
      return { ...state, otpModal: action.payload };
    case ActionType.SET_LOGIN_STATE:
      return { ...state, loginValues: { ...state.loginValues, ...action.payload } };
    case ActionType.SET_LOGIN_SKIP:
      return { ...state, loginSkip: action.payload };
    case ActionType.SET_GUEST_LOGGED_IN:
      return { ...state, guestLoggedIn: action.payload };
    case ActionType.SET_PENDING_CHECKOUT:
      return { ...state, pendingCheckout: action.payload };
    default:
      return state;
  }
};
export default reducer;
